<ng-container *transloco="let t; read: 'user'">
  <div class="fix-action-row modal-body">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">{{ t('manageEnrollment.reEnrollClassroom.title') }}</h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>

    @if (displayResult) {
      <div mat-dialog-content>
        @if (ratingOptions.length != 0) {
          <div class="content py-3">
            <span>{{ t('manageEnrollment.reEnrollClassroom.classLevelAgeGradeNote') }}</span>
            <form [formGroup]="reEnrollmentForm">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="font-normal">{{ t('manageEnrollment.myClasses.columns.classroom') }}</label>
                  <!-- Classroom name is server-supplied. -->
                  <p>{{ data.name }}</p>
                </div>
                <div>
                  <label class="font-normal">{{ t('manageEnrollment.myClasses.columns.ratingPeriod') }}</label>
                  <mat-select [placeholder]="t('manageEnrollment.reEnrollClassroom.ratingPeriodPlaceholder')" formControlName="ratingPeriodId"
                    (selectionChange)="handleRatingPeriod($event)">
                    @for (rating of ratingOptions; track rating) {
                      <mat-option [value]="rating.id">
                        <!-- Rating period name is server-supplied. -->
                        {{ rating.ratingPeriodName }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
                @if (requireAgeGrade) {
                  <div>
                    <drdp-select-age-grade
                      [stateId]="data.stateId" 
                      [label]="t('manageEnrollment.reEnrollClassroom.ageGradeLabel')"
                      [multiSelect]="false"
                      [required]="true"
                      [isPilot]="true"
                      [schoolYearId]="selectedSchoolYearId"
                      (ageGrade)="handleAgeGrade($event)">
                    </drdp-select-age-grade>
                  </div>
                }
              </div>
            </form>
            <div class="pt-3">
              <drdp-rating-periods [agencyId]="data.agencyId"></drdp-rating-periods>
            </div>
          </div>
        } @else {
          <div class="flex flex-row mt-2">
            <p>{{ t('manageEnrollment.reEnrollClassroom.noRatingPeriodsLeft') }}</p>
          </div>
        }
      </div>
    }
    <div class="spacer"></div>
    <div mat-dialog-actions class="flex flex-row justify-end">
      <drdp-btn color="cancel" class="mr-3" mat-button mat-dialog-close>
        {{ t('manageEnrollment.myClasses.actions.cancel') }}
      </drdp-btn>
      <drdp-btn color="blue" [disabled]="reEnrollmentForm.invalid || isProcessing" mat-button (click)="submit()">
        {{ submitBtnText }}
      </drdp-btn>
    </div>
  </div>
</ng-container>